import React from 'react';
import classNames from 'classnames';
import Avatar from '../../../components/Avatar';

interface AvatarItem {
  name: string;
  description?: string;
  imageUrl?: string;
  url?: string;
}

interface StackedAvatarsProps {
  items: AvatarItem[];
  maxDisplay?: number;
  className?: string;
  onAvatarClick?: (item: AvatarItem) => void;
}

const StackedAvatars: React.FC<StackedAvatarsProps> = ({
  items,
  maxDisplay = 3,
  className = '',
  onAvatarClick,
}) => {
  if (!items?.length) {
    return <span className="text-neutral-100">—</span>;
  }

  const displayedItems = items.slice(0, maxDisplay);
  const remainingCount = items.length - maxDisplay;

  return (
    <div
      className={`flex items-center ${className}`}
      style={{ overflow: 'visible' }}
    >
      {displayedItems.map((item, index) => (
        <div
          key={index}
          className={classNames('relative', index !== 0 && '-ml-3')}
          style={{ overflow: 'visible' }}
        >
          <div>
            {item.url ? (
              <div
                onClick={() => onAvatarClick?.(item)}
                className="block cursor-pointer transition-transform hover:scale-105"
              >
                <Avatar
                  name={item.name}
                  imageUrl={item.imageUrl}
                  size="medium"
                  className="border-2 border-white hover:z-10"
                  textClassName="bg-neutral-50 text-neutral-125"
                />
              </div>
            ) : (
              <Avatar
                name={item.name}
                imageUrl={item.imageUrl}
                size="medium"
                className="border-2 border-white hover:z-10"
                textClassName="bg-neutral-50 text-neutral-125"
              />
            )}
          </div>
        </div>
      ))}
      {remainingCount > 0 && (
        <div className="relative -ml-3">
          <div className="text-xs flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-neutral-50 font-medium text-neutral-125">
            +{remainingCount}
          </div>
        </div>
      )}
    </div>
  );
};

export default StackedAvatars;
